<div
  class="entity-summary-renderer"
  [ngClass]="containerClasses"
>
  <div
    class="entity-summary-renderer__title"
    (click)="onCellClick($event)"
  >
    {{ title }}
  </div>
  <div
    class="entity-summary-renderer__sub-title"
    (click)="onCellClick($event)"
  >
    {{ subTitle }}
  </div>
</div>
